<template>

  <el-main class="main_content" style="padding: 0">
    <div class="cont_navs_header_board">
      <el-breadcrumb separator="/" class="bread">
        <el-breadcrumb-item :to="{ path: '/AreaDashboard' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>dashboard</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>控制台</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <el-row class="clr">
        <el-col :span="14">
          <el-row>
            <el-col :span="3">
              <img style="width:72px;height:72px;" src="../assets/BiazfanxmamNRoxxVxka.png">
            </el-col>
            <el-col :span="21">
              <p style="font-size: 20px;line-height: 28px;font-weight: 500;color: rgba(0,0,0,.85);margin-bottom: 12px;">您好，管理员，祝你开心每一天！</p>
              <span style="color: rgba(0,0,0,.45);">您负责的省份如下：{{provinceList}}</span>
            </el-col>

          </el-row>
        </el-col>
        
      </el-row>
    </div>

    
    <!-- 用户总数  帖子总数 房产总数
    快捷导航
    上架中的房产
    上架中的活动
    文章列表 -->

  </el-main>
</template>


<script>
import { bus } from "../bus.js";
import API from "../api/api_user";
var _ = require("lodash");
export default {
  name: "Dashboard",
  methods: {
    hasPower(power) {
      var has = false;
      for (var i = 0; i < this.powers.length; i++) {
        if (this.powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    jumpTo(url, baseUrl, id) {
      bus.$emit('goto', url, baseUrl, {id:id})
      // this.defaultActiveIndex = url;
      // this.$router.push(url); //用go刷新
    },
  },
  data() {
    return {
      powers:[],
      orderPay:0,
      orderSend:0,
      orderCon:0,
      orderFini:0,
      orderCnac:0,
      no_house: false,
      currentDate: "2017-12-12",
      contain_loading: true,
      acList: [],
      houseList: [],
      sendNum:[],
      totalMoney:null,
      articleList: [],
      totalHouse: null,
      totalActivity: null,
      provinceList:'',
      totalInAc: null,
      totalPost: null,
      waitComplain:null,
      waitJudge:null
    };
  },
  mounted(e) {
    //初始化表单
    var that = this;
    let powers = localStorage.getItem("powers");
    this.provinceList  = localStorage.getItem("provinceList");
    this.powers = JSON.parse(powers);
    // var para = {
    //   token: localStorage.getItem("api_token")
    // };
    that.contain_loading = false;
    // API.dashboard(para)
    //   .then(
    //     function(result) {
    //       that.contain_loading = false;
    //       if (result.key == 1000) {
    //         that.acList = result.result.map.acList;
    //         that.houseList = result.result.map.houseList;

    //         that.totalMoney = result.result.map.totalMoney;
    //         that.waitComplain = result.result.map.waitComplain;
    //         that.waitJudge = result.result.map.waitJudge;
    //         that.sendNum = result.result.map.sendNum;

    //         that.orderPay = 0;
    //         that.orderSend = 0;
    //         that.orderCon = 0;
    //         that.orderFini = 0;
    //         that.orderCnac = 0;
    //         if (result.result.map.sendNum != null && result.result.map.sendNum.length > 0) {
    //           for (var i=0; i<result.result.map.sendNum.length; i++) {
    //             if (parseInt(result.result.map.sendNum[i].status) == 1 || parseInt(result.result.map.sendNum[i].status) == 10) {
    //               that.orderPay = parseInt(result.result.map.sendNum[i].num);
    //             } else if (parseInt(result.result.map.sendNum[i].status) == 2) {
    //               that.orderSend = parseInt(result.result.map.sendNum[i].num);
    //             } else if (parseInt(result.result.map.sendNum[i].status) == 3) {
    //               that.orderCon = parseInt(result.result.map.sendNum[i].num);
    //             } else if (parseInt(result.result.map.sendNum[i].status) == 4) {
    //               that.orderFini = parseInt(result.result.map.sendNum[i].num);
    //             } else if (parseInt(result.result.map.sendNum[i].status) == 5) {
    //               that.orderCnac = parseInt(result.result.map.sendNum[i].num);
    //             }
    //           }
    //         }
    //         that.totalHouse = result.result.map.totalHouse;
    //         that.totalActivity = result.result.map.totalActivity;
    //         that.totalInAc = result.result.map.totalInAc;
    //         that.totalPost = result.result.map.totalPost;
    //       } else {
    //         that.$message.error({
    //           showClose: true,
    //           message: result.message || "登录失败",
    //           duration: 2000
    //         });
    //       }
    //     },
    //     function(err) {
    //       that.loading = false;
    //       that.$message.error({
    //         showClose: true,
    //         message: err.toString(),
    //         duration: 2000
    //       });
    //     }
    //   )
    //   .catch(function(error) {
    //     that.loading = false;
    //     console.log(error);
    //     that.$message.error({
    //       showClose: true,
    //       message: "请求出现异常",
    //       duration: 2000
    //     });
    //   });
  }
};
</script>

<style>
.inie-fia{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  border-bottom: 1px solid #ebeef5;
}
.inie-fia>span:nth-child(2)
{
  font-size: 20px;
}
.inie{
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #ebeef5;
}
.inie>span:nth-child(2)
{
  font-size: 20px;
}
.nav_third {
  color: rgba(0, 0, 0, 0.45);
}
.num_nav {
  color: rgba(0, 0, 0, 0.85);
  font-size: 30px;
  line-height: 38px;
  margin: 0;
}
.nav_border:after {
  background-color: #e8e8e8;
  position: absolute;
  top: 8px;
  right: 0;
  width: 1px;
  height: 40px;
  content: "";
}
.cont_navs_header_board {
  background-color: #fff;
  width: 100%;
  /* height: 55px; */
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  padding-left: 20px;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;
}
.bread {
  margin-bottom: 16px;
}
.grid-content {
  position: relative;
  padding: 26px 30px 0 35px;
  min-height: 140px;
  background-color: #ed5565;
}
.grid_center_info {
  color: #ffff;
}
.grid-content::after {
  position: absolute;
  right: 7px;
  content: "\e65d";
  bottom: 0px;
  font-family: icon_web !important;
}
.bot-content {
  position: relative;
}
.grid_center_info h5 {
  color: #fff;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1;
  margin: 0 0 5px 0;
}
.count {
  display: block;
  color: #fff;
  font: normal 46px/1 Arial, sans-serif;
  margin: 0 0 13px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tips {
  font-size: 1rem;
  line-height: 1;
  margin: 0;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}
.image_ac{
  width: 100%;
  display: block;
  height: 125px;
}
.image {
  width: 100%;
  display: block;
  height: 160px;
}
.quick_a {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: -10px;
  margin-top: -10px;
}
.quick_a > button {
  flex-basis: 20%;
  cursor: pointer;
  margin-top: 10px;
}
.quick_a > a:hover {
  background: rgb(255, 255, 255);
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/components/AreaDashboard.vue